import { CheckCircle, XCircle } from 'lucide-react'

interface GateCardProps {
  label: string
  passed: boolean
  message: string
}

function GateCard({ label, passed, message }: GateCardProps): React.ReactElement {
  const borderClass = passed
    ? 'border-green-400 bg-green-50 dark:bg-green-900/20'
    : 'border-red-400 bg-red-50 dark:bg-red-900/20'
  return (
    <div className={`rounded-lg border-2 p-4 ${borderClass}`}>
      <div className="mb-2 flex items-center gap-2">
        {passed ? (
          <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400" />
        ) : (
          <XCircle className="h-5 w-5 text-red-600 dark:text-red-400" />
        )}
        <span className="font-medium text-stone-900 dark:text-stone-100">{label}</span>
      </div>
      <p className="text-sm text-stone-600 dark:text-stone-400">{message}</p>
    </div>
  )
}

interface CreateLicenseGateCardsProps {
  hasPaymentGate: boolean
  hasLicenseGate: boolean
  paymentGateMessage: string
  licenseGateMessage: string
}

export function CreateLicenseGateCards(props: CreateLicenseGateCardsProps): React.ReactElement {
  const { hasPaymentGate, hasLicenseGate, paymentGateMessage, licenseGateMessage } = props
  return (
    <div className="grid grid-cols-2 gap-4">
      <GateCard label="Payment Gate" passed={hasPaymentGate} message={paymentGateMessage} />
      <GateCard label="License Gate" passed={hasLicenseGate} message={licenseGateMessage} />
    </div>
  )
}
